// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/Fill/at/black.png';
import img1 from '@images/UI/Fill/at/black@2x.png';
import img2 from '@images/UI/Fill/at/black@3x.png';
import img3 from '@images/UI/Fill/coupon-discount/grey.png';
import img4 from '@images/UI/Fill/coupon-discount/grey@2x.png';
import img5 from '@images/UI/Fill/coupon-discount/grey@3x.png';
import img6 from '@images/UI/Fill/trash-2/black.png';
import img7 from '@images/UI/Fill/trash-2/black@2x.png';
import img8 from '@images/UI/Fill/trash-2/black@3x.png';
import img9 from '@images/UI/Fill/battery/black.png';
import img10 from '@images/UI/Fill/battery/black@2x.png';
import img11 from '@images/UI/Fill/battery/black@3x.png';
import img12 from '@images/UI/Fill/file-text/black.png';
import img13 from '@images/UI/Fill/file-text/black@2x.png';
import img14 from '@images/UI/Fill/file-text/black@3x.png';
import img15 from '@images/UI/Fill/file-text/darkRed.png';
import img16 from '@images/UI/Fill/file-text/darkRed@2x.png';
import img17 from '@images/UI/Fill/file-text/darkRed@3x.png';
import img18 from '@images/UI/Fill/wine/black.png';
import img19 from '@images/UI/Fill/wine/black@2x.png';
import img20 from '@images/UI/Fill/wine/black@3x.png';
import img21 from '@images/UI/Fill/wine/purple.png';
import img22 from '@images/UI/Fill/wine/purple@2x.png';
import img23 from '@images/UI/Fill/wine/purple@3x.png';
import img24 from '@images/UI/Fill/undo/red.png';
import img25 from '@images/UI/Fill/undo/red@2x.png';
import img26 from '@images/UI/Fill/undo/red@3x.png';
import img27 from '@images/UI/Fill/crab/red.png';
import img28 from '@images/UI/Fill/crab/red@2x.png';
import img29 from '@images/UI/Fill/crab/red@3x.png';
import img30 from '@images/UI/Fill/star_rounded/yellow.png';
import img31 from '@images/UI/Fill/star_rounded/yellow@2x.png';
import img32 from '@images/UI/Fill/star_rounded/yellow@3x.png';
import img33 from '@images/UI/Fill/star_rounded/lightYellow.png';
import img34 from '@images/UI/Fill/star_rounded/lightYellow@2x.png';
import img35 from '@images/UI/Fill/star_rounded/lightYellow@3x.png';
import img36 from '@images/UI/Fill/quotations/red.png';
import img37 from '@images/UI/Fill/quotations/red@2x.png';
import img38 from '@images/UI/Fill/quotations/red@3x.png';
import img39 from '@images/UI/Fill/playRounded/white.png';
import img40 from '@images/UI/Fill/playRounded/white@2x.png';
import img41 from '@images/UI/Fill/playRounded/white@3x.png';
import img42 from '@images/UI/Fill/info/black.png';
import img43 from '@images/UI/Fill/info/black@2x.png';
import img44 from '@images/UI/Fill/info/black@3x.png';
import img45 from '@images/UI/Fill/info/darkGrey.png';
import img46 from '@images/UI/Fill/info/darkGrey@2x.png';
import img47 from '@images/UI/Fill/info/darkGrey@3x.png';
import img48 from '@images/UI/Fill/info/red.png';
import img49 from '@images/UI/Fill/info/red@2x.png';
import img50 from '@images/UI/Fill/info/red@3x.png';
import img51 from '@images/UI/Fill/car/black.png';
import img52 from '@images/UI/Fill/car/black@2x.png';
import img53 from '@images/UI/Fill/car/black@3x.png';
import img54 from '@images/UI/Fill/car/orange.png';
import img55 from '@images/UI/Fill/car/orange@2x.png';
import img56 from '@images/UI/Fill/car/orange@3x.png';
import img57 from '@images/UI/Fill/scale/black.png';
import img58 from '@images/UI/Fill/scale/black@2x.png';
import img59 from '@images/UI/Fill/scale/black@3x.png';
import img60 from '@images/UI/Fill/question-mark-circle/darkGrey.png';
import img61 from '@images/UI/Fill/question-mark-circle/darkGrey@2x.png';
import img62 from '@images/UI/Fill/question-mark-circle/darkGrey@3x.png';
import img63 from '@images/UI/Fill/question-mark-circle/black.png';
import img64 from '@images/UI/Fill/question-mark-circle/black@2x.png';
import img65 from '@images/UI/Fill/question-mark-circle/black@3x.png';
import img66 from '@images/UI/Fill/alert-circle/black.png';
import img67 from '@images/UI/Fill/alert-circle/black@2x.png';
import img68 from '@images/UI/Fill/alert-circle/black@3x.png';
import img69 from '@images/UI/Fill/alert-circle/grey.png';
import img70 from '@images/UI/Fill/alert-circle/grey@2x.png';
import img71 from '@images/UI/Fill/alert-circle/grey@3x.png';
import img72 from '@images/UI/Fill/alert-circle/lightGrey.png';
import img73 from '@images/UI/Fill/alert-circle/lightGrey@2x.png';
import img74 from '@images/UI/Fill/alert-circle/lightGrey@3x.png';
import img75 from '@images/UI/Fill/message-circle/white.png';
import img76 from '@images/UI/Fill/message-circle/white@2x.png';
import img77 from '@images/UI/Fill/message-circle/white@3x.png';
import img78 from '@images/UI/Fill/message-circle/darkGrey.png';
import img79 from '@images/UI/Fill/message-circle/darkGrey@2x.png';
import img80 from '@images/UI/Fill/message-circle/darkGrey@3x.png';
import img81 from '@images/UI/Fill/message-circle/midGrey.png';
import img82 from '@images/UI/Fill/message-circle/midGrey@2x.png';
import img83 from '@images/UI/Fill/message-circle/midGrey@3x.png';
import img84 from '@images/UI/Fill/message-circle/red.png';
import img85 from '@images/UI/Fill/message-circle/red@2x.png';
import img86 from '@images/UI/Fill/message-circle/red@3x.png';
import img87 from '@images/UI/Fill/bar-chart-2/midGrey.png';
import img88 from '@images/UI/Fill/bar-chart-2/midGrey@2x.png';
import img89 from '@images/UI/Fill/bar-chart-2/midGrey@3x.png';
import img90 from '@images/UI/Fill/timer/black.png';
import img91 from '@images/UI/Fill/timer/black@2x.png';
import img92 from '@images/UI/Fill/timer/black@3x.png';
import img93 from '@images/UI/Fill/timer/scarlet.png';
import img94 from '@images/UI/Fill/timer/scarlet@2x.png';
import img95 from '@images/UI/Fill/timer/scarlet@3x.png';
import img96 from '@images/UI/Fill/timer/red.png';
import img97 from '@images/UI/Fill/timer/red@2x.png';
import img98 from '@images/UI/Fill/timer/red@3x.png';
import img99 from '@images/UI/Fill/timer/white.png';
import img100 from '@images/UI/Fill/timer/white@2x.png';
import img101 from '@images/UI/Fill/timer/white@3x.png';
import img102 from '@images/UI/Fill/timer/darkGrey.png';
import img103 from '@images/UI/Fill/timer/darkGrey@2x.png';
import img104 from '@images/UI/Fill/timer/darkGrey@3x.png';
import img105 from '@images/UI/Fill/timer/midGrey.png';
import img106 from '@images/UI/Fill/timer/midGrey@2x.png';
import img107 from '@images/UI/Fill/timer/midGrey@3x.png';
import img108 from '@images/UI/Fill/pricetag/midYellow.png';
import img109 from '@images/UI/Fill/pricetag/midYellow@2x.png';
import img110 from '@images/UI/Fill/pricetag/midYellow@3x.png';
import img111 from '@images/UI/Fill/pricetag/red.png';
import img112 from '@images/UI/Fill/pricetag/red@2x.png';
import img113 from '@images/UI/Fill/pricetag/red@3x.png';
import img114 from '@images/UI/Fill/pricetag/black.png';
import img115 from '@images/UI/Fill/pricetag/black@2x.png';
import img116 from '@images/UI/Fill/pricetag/black@3x.png';
import img117 from '@images/UI/Fill/cart/black.png';
import img118 from '@images/UI/Fill/cart/black@2x.png';
import img119 from '@images/UI/Fill/cart/black@3x.png';
import img120 from '@images/UI/Fill/cart/darkGrey.png';
import img121 from '@images/UI/Fill/cart/darkGrey@2x.png';
import img122 from '@images/UI/Fill/cart/darkGrey@3x.png';
import img123 from '@images/UI/Fill/cart/red.png';
import img124 from '@images/UI/Fill/cart/red@2x.png';
import img125 from '@images/UI/Fill/cart/red@3x.png';
import img126 from '@images/UI/Fill/download/black.png';
import img127 from '@images/UI/Fill/download/black@2x.png';
import img128 from '@images/UI/Fill/download/black@3x.png';
import img129 from '@images/UI/Fill/person/black.png';
import img130 from '@images/UI/Fill/person/black@2x.png';
import img131 from '@images/UI/Fill/person/black@3x.png';
import img132 from '@images/UI/Fill/person/red.png';
import img133 from '@images/UI/Fill/person/red@2x.png';
import img134 from '@images/UI/Fill/person/red@3x.png';
import img135 from '@images/UI/Fill/person/darkGrey.png';
import img136 from '@images/UI/Fill/person/darkGrey@2x.png';
import img137 from '@images/UI/Fill/person/darkGrey@3x.png';
import img138 from '@images/UI/Fill/person/midGrey.png';
import img139 from '@images/UI/Fill/person/midGrey@2x.png';
import img140 from '@images/UI/Fill/person/midGrey@3x.png';
import img141 from '@images/UI/Fill/person-done/black.png';
import img142 from '@images/UI/Fill/person-done/black@2x.png';
import img143 from '@images/UI/Fill/person-done/black@3x.png';
import img144 from '@images/UI/Fill/flash/red.png';
import img145 from '@images/UI/Fill/flash/red@2x.png';
import img146 from '@images/UI/Fill/flash/red@3x.png';
import img147 from '@images/UI/Fill/share/darkGrey.png';
import img148 from '@images/UI/Fill/share/darkGrey@2x.png';
import img149 from '@images/UI/Fill/share/darkGrey@3x.png';
import img150 from '@images/UI/Fill/share/red.png';
import img151 from '@images/UI/Fill/share/red@2x.png';
import img152 from '@images/UI/Fill/share/red@3x.png';
import img153 from '@images/UI/Fill/share/white.png';
import img154 from '@images/UI/Fill/share/white@2x.png';
import img155 from '@images/UI/Fill/share/white@3x.png';
import img156 from '@images/UI/Fill/share/black.png';
import img157 from '@images/UI/Fill/share/black@2x.png';
import img158 from '@images/UI/Fill/share/black@3x.png';
import img159 from '@images/UI/Fill/share/ultraDG.png';
import img160 from '@images/UI/Fill/share/ultraDG@2x.png';
import img161 from '@images/UI/Fill/share/ultraDG@3x.png';
import img162 from '@images/UI/Fill/fire/red.png';
import img163 from '@images/UI/Fill/fire/red@2x.png';
import img164 from '@images/UI/Fill/fire/red@3x.png';
import img165 from '@images/UI/Fill/fire/black.png';
import img166 from '@images/UI/Fill/fire/black@2x.png';
import img167 from '@images/UI/Fill/fire/black@3x.png';
import img168 from '@images/UI/Fill/fire/salmon.png';
import img169 from '@images/UI/Fill/fire/salmon@2x.png';
import img170 from '@images/UI/Fill/fire/salmon@3x.png';
import img171 from '@images/UI/Fill/fire/midGrey.png';
import img172 from '@images/UI/Fill/fire/midGrey@2x.png';
import img173 from '@images/UI/Fill/fire/midGrey@3x.png';
import img174 from '@images/UI/Fill/carItalic/black.png';
import img175 from '@images/UI/Fill/carItalic/black@2x.png';
import img176 from '@images/UI/Fill/carItalic/black@3x.png';
import img177 from '@images/UI/Fill/carItalic/white.png';
import img178 from '@images/UI/Fill/carItalic/white@2x.png';
import img179 from '@images/UI/Fill/carItalic/white@3x.png';
import img180 from '@images/UI/Fill/store/ultraDG.png';
import img181 from '@images/UI/Fill/store/ultraDG@2x.png';
import img182 from '@images/UI/Fill/store/ultraDG@3x.png';
import img183 from '@images/UI/Fill/store/black.png';
import img184 from '@images/UI/Fill/store/black@2x.png';
import img185 from '@images/UI/Fill/store/black@3x.png';
import img186 from '@images/UI/Fill/store/red.png';
import img187 from '@images/UI/Fill/store/red@2x.png';
import img188 from '@images/UI/Fill/store/red@3x.png';
import img189 from '@images/UI/Fill/store/pink.png';
import img190 from '@images/UI/Fill/store/pink@2x.png';
import img191 from '@images/UI/Fill/store/pink@3x.png';
import img192 from '@images/UI/Fill/store/white.png';
import img193 from '@images/UI/Fill/store/white@2x.png';
import img194 from '@images/UI/Fill/store/white@3x.png';
import img195 from '@images/UI/Fill/store/purple.png';
import img196 from '@images/UI/Fill/store/purple@2x.png';
import img197 from '@images/UI/Fill/store/purple@3x.png';
import img198 from '@images/UI/Fill/award/red.png';
import img199 from '@images/UI/Fill/award/red@2x.png';
import img200 from '@images/UI/Fill/award/red@3x.png';
import img201 from '@images/UI/Fill/award/midYellow.png';
import img202 from '@images/UI/Fill/award/midYellow@2x.png';
import img203 from '@images/UI/Fill/award/midYellow@3x.png';
import img204 from '@images/UI/Fill/award/yellow.png';
import img205 from '@images/UI/Fill/award/yellow@2x.png';
import img206 from '@images/UI/Fill/award/yellow@3x.png';
import img207 from '@images/UI/Fill/award/black.png';
import img208 from '@images/UI/Fill/award/black@2x.png';
import img209 from '@images/UI/Fill/award/black@3x.png';
import img210 from '@images/UI/Fill/phone/midYellow.png';
import img211 from '@images/UI/Fill/phone/midYellow@2x.png';
import img212 from '@images/UI/Fill/phone/midYellow@3x.png';
import img213 from '@images/UI/Fill/phone/yellow.png';
import img214 from '@images/UI/Fill/phone/yellow@2x.png';
import img215 from '@images/UI/Fill/phone/yellow@3x.png';
import img216 from '@images/UI/Fill/phone/black.png';
import img217 from '@images/UI/Fill/phone/black@2x.png';
import img218 from '@images/UI/Fill/phone/black@3x.png';
import img219 from '@images/UI/Fill/phone-missed/black.png';
import img220 from '@images/UI/Fill/phone-missed/black@2x.png';
import img221 from '@images/UI/Fill/phone-missed/black@3x.png';
import img222 from '@images/UI/Fill/phone24/black.png';
import img223 from '@images/UI/Fill/phone24/black@2x.png';
import img224 from '@images/UI/Fill/phone24/black@3x.png';
import img225 from '@images/UI/Fill/checkmark-circle/black.png';
import img226 from '@images/UI/Fill/checkmark-circle/black@2x.png';
import img227 from '@images/UI/Fill/checkmark-circle/black@3x.png';
import img228 from '@images/UI/Fill/checkmark-circle/grey.png';
import img229 from '@images/UI/Fill/checkmark-circle/grey@2x.png';
import img230 from '@images/UI/Fill/checkmark-circle/grey@3x.png';
import img231 from '@images/UI/Fill/checkmark-circle/red.png';
import img232 from '@images/UI/Fill/checkmark-circle/red@2x.png';
import img233 from '@images/UI/Fill/checkmark-circle/red@3x.png';
import img234 from '@images/UI/Fill/checkmark-circle/purple.png';
import img235 from '@images/UI/Fill/checkmark-circle/purple@2x.png';
import img236 from '@images/UI/Fill/checkmark-circle/purple@3x.png';
import img237 from '@images/UI/Fill/checkmark-circle/white.png';
import img238 from '@images/UI/Fill/checkmark-circle/white@2x.png';
import img239 from '@images/UI/Fill/checkmark-circle/white@3x.png';
import img240 from '@images/UI/Fill/bookmark/red.png';
import img241 from '@images/UI/Fill/bookmark/red@2x.png';
import img242 from '@images/UI/Fill/bookmark/red@3x.png';
import img243 from '@images/UI/Fill/bookmark/darkGrey.png';
import img244 from '@images/UI/Fill/bookmark/darkGrey@2x.png';
import img245 from '@images/UI/Fill/bookmark/darkGrey@3x.png';
import img246 from '@images/UI/Fill/eye/white.png';
import img247 from '@images/UI/Fill/eye/white@2x.png';
import img248 from '@images/UI/Fill/eye/white@3x.png';
import img249 from '@images/UI/Fill/eye/darkGrey.png';
import img250 from '@images/UI/Fill/eye/darkGrey@2x.png';
import img251 from '@images/UI/Fill/eye/darkGrey@3x.png';
import img252 from '@images/UI/Fill/bell/darkRed.png';
import img253 from '@images/UI/Fill/bell/darkRed@2x.png';
import img254 from '@images/UI/Fill/bell/darkRed@3x.png';
import img255 from '@images/UI/Fill/heart/black.png';
import img256 from '@images/UI/Fill/heart/black@2x.png';
import img257 from '@images/UI/Fill/heart/black@3x.png';
import img258 from '@images/UI/Fill/heart/darkRed.png';
import img259 from '@images/UI/Fill/heart/darkRed@2x.png';
import img260 from '@images/UI/Fill/heart/darkRed@3x.png';
import img261 from '@images/UI/Fill/heart/red.png';
import img262 from '@images/UI/Fill/heart/red@2x.png';
import img263 from '@images/UI/Fill/heart/red@3x.png';
import img264 from '@images/UI/Fill/star/midYellow.png';
import img265 from '@images/UI/Fill/star/midYellow@2x.png';
import img266 from '@images/UI/Fill/star/midYellow@3x.png';
import img267 from '@images/UI/Fill/star/red.png';
import img268 from '@images/UI/Fill/star/red@2x.png';
import img269 from '@images/UI/Fill/star/red@3x.png';
import img270 from '@images/UI/Fill/star/yellow.png';
import img271 from '@images/UI/Fill/star/yellow@2x.png';
import img272 from '@images/UI/Fill/star/yellow@3x.png';
import img273 from '@images/UI/Fill/star/grey.png';
import img274 from '@images/UI/Fill/star/grey@2x.png';
import img275 from '@images/UI/Fill/star/grey@3x.png';
import img276 from '@images/UI/Fill/close-circle/darkGrey.png';
import img277 from '@images/UI/Fill/close-circle/darkGrey@2x.png';
import img278 from '@images/UI/Fill/close-circle/darkGrey@3x.png';
import img279 from '@images/UI/Fill/close-circle/white.png';
import img280 from '@images/UI/Fill/close-circle/white@2x.png';
import img281 from '@images/UI/Fill/close-circle/white@3x.png';
import img282 from '@images/UI/Fill/close/midGrey.png';
import img283 from '@images/UI/Fill/close/midGrey@2x.png';
import img284 from '@images/UI/Fill/close/midGrey@3x.png';
import img285 from '@images/UI/Fill/gift/red.png';
import img286 from '@images/UI/Fill/gift/red@3x.png';
import img287 from '@images/UI/Fill/gift/red@2x.png';
import img288 from '@images/UI/Fill/gift/darkRed.png';
import img289 from '@images/UI/Fill/gift/darkRed@3x.png';
import img290 from '@images/UI/Fill/gift/darkRed@2x.png';
import img291 from '@images/UI/Fill/gift/white.png';
import img292 from '@images/UI/Fill/gift/white@3x.png';
import img293 from '@images/UI/Fill/gift/white@2x.png';
import img294 from '@images/UI/Fill/gift/dark.png';
import img295 from '@images/UI/Fill/gift/dark@3x.png';
import img296 from '@images/UI/Fill/gift/dark@2x.png';
import img297 from '@images/UI/Fill/fast-delivery/red.png';
import img298 from '@images/UI/Fill/fast-delivery/red@2x.png';
import img299 from '@images/UI/Fill/fast-delivery/red@3x.png';
import img300 from '@images/UI/Fill/inbox/black.png';
import img301 from '@images/UI/Fill/inbox/black@2x.png';
import img302 from '@images/UI/Fill/inbox/black@3x.png';
import img303 from '@images/UI/Fill/calendar/white.png';
import img304 from '@images/UI/Fill/calendar/white@2x.png';
import img305 from '@images/UI/Fill/calendar/white@3x.png';
import img306 from '@images/UI/Fill/calendar/darkGrey.png';
import img307 from '@images/UI/Fill/calendar/darkGrey@2x.png';
import img308 from '@images/UI/Fill/calendar/darkGrey@3x.png';
import img309 from '@images/UI/Fill/calendar/black.png';
import img310 from '@images/UI/Fill/calendar/black@2x.png';
import img311 from '@images/UI/Fill/calendar/black@3x.png';
import img312 from '@images/UI/Fill/ruble/black.png';
import img313 from '@images/UI/Fill/ruble/black@2x.png';
import img314 from '@images/UI/Fill/ruble/black@3x.png';
import img315 from '@images/UI/Fill/ruble/red.png';
import img316 from '@images/UI/Fill/ruble/red@2x.png';
import img317 from '@images/UI/Fill/ruble/red@3x.png';
import img318 from '@images/UI/Fill/clock/black.png';
import img319 from '@images/UI/Fill/clock/black@2x.png';
import img320 from '@images/UI/Fill/clock/black@3x.png';
import img321 from '@images/UI/Fill/clock/grey.png';
import img322 from '@images/UI/Fill/clock/grey@2x.png';
import img323 from '@images/UI/Fill/clock/grey@3x.png';
import img324 from '@images/UI/Fill/parking/black.png';
import img325 from '@images/UI/Fill/parking/black@2x.png';
import img326 from '@images/UI/Fill/parking/black@3x.png';
import img327 from '@images/UI/Fill/pin/black.png';
import img328 from '@images/UI/Fill/pin/black@2x.png';
import img329 from '@images/UI/Fill/pin/black@3x.png';
import img330 from '@images/UI/Fill/pin/red.png';
import img331 from '@images/UI/Fill/pin/red@2x.png';
import img332 from '@images/UI/Fill/pin/red@3x.png';
import pinWhite from '@images/UI/Fill/pin/white.png';
import pinWhite2x from '@images/UI/Fill/pin/white@2x.png';
import pinWhite3x from '@images/UI/Fill/pin/white@3x.png';
import img333 from '@images/UI/Fill/free-delivery/black.png';
import img334 from '@images/UI/Fill/free-delivery/black@2x.png';
import img335 from '@images/UI/Fill/free-delivery/black@3x.png';
import img336 from '@images/UI/Fill/free-delivery/red.png';
import img337 from '@images/UI/Fill/free-delivery/red@2x.png';
import img338 from '@images/UI/Fill/free-delivery/red@3x.png';
import img339 from '@images/UI/Fill/social/dzen/grey.png';
import img340 from '@images/UI/Fill/social/dzen/grey@2x.png';
import img341 from '@images/UI/Fill/social/dzen/grey@3x.png';
import img342 from '@images/UI/Fill/social/dzen/darkGrey.png';
import img343 from '@images/UI/Fill/social/dzen/darkGrey@2x.png';
import img344 from '@images/UI/Fill/social/dzen/darkGrey@3x.png';
import img345 from '@images/UI/Fill/social/dzen/red.png';
import img346 from '@images/UI/Fill/social/dzen/red@2x.png';
import img347 from '@images/UI/Fill/social/dzen/red@3x.png';
import img348 from '@images/UI/Fill/social/dzen/ultraDG.png';
import img349 from '@images/UI/Fill/social/dzen/ultraDG@2x.png';
import img350 from '@images/UI/Fill/social/dzen/ultraDG@3x.png';
import img351 from '@images/UI/Fill/social/max/red.png';
import img352 from '@images/UI/Fill/social/max/red@2x.png';
import img353 from '@images/UI/Fill/social/max/red@3x.png';
import img354 from '@images/UI/Fill/social/max/ultraDG.png';
import img355 from '@images/UI/Fill/social/max/ultraDG@2x.png';
import img356 from '@images/UI/Fill/social/max/ultraDG@3x.png';
import img357 from '@images/UI/Fill/social/facebook/grey.png';
import img358 from '@images/UI/Fill/social/facebook/grey@2x.png';
import img359 from '@images/UI/Fill/social/facebook/grey@3x.png';
import img360 from '@images/UI/Fill/social/facebook/red.png';
import img361 from '@images/UI/Fill/social/facebook/red@2x.png';
import img362 from '@images/UI/Fill/social/facebook/red@3x.png';
import img363 from '@images/UI/Fill/social/instagram/grey.png';
import img364 from '@images/UI/Fill/social/instagram/grey@2x.png';
import img365 from '@images/UI/Fill/social/instagram/grey@3x.png';
import img366 from '@images/UI/Fill/social/instagram/red.png';
import img367 from '@images/UI/Fill/social/instagram/red@2x.png';
import img368 from '@images/UI/Fill/social/instagram/red@3x.png';
import img369 from '@images/UI/Fill/social/ok/grey.png';
import img370 from '@images/UI/Fill/social/ok/grey@2x.png';
import img371 from '@images/UI/Fill/social/ok/grey@3x.png';
import img372 from '@images/UI/Fill/social/ok/darkGrey.png';
import img373 from '@images/UI/Fill/social/ok/darkGrey@2x.png';
import img374 from '@images/UI/Fill/social/ok/darkGrey@3x.png';
import img375 from '@images/UI/Fill/social/ok/red.png';
import img376 from '@images/UI/Fill/social/ok/red@2x.png';
import img377 from '@images/UI/Fill/social/ok/red@3x.png';
import img378 from '@images/UI/Fill/social/ok/ultraDG.png';
import img379 from '@images/UI/Fill/social/ok/ultraDG@2x.png';
import img380 from '@images/UI/Fill/social/ok/ultraDG@3x.png';
import img381 from '@images/UI/Fill/social/tiktok/grey.png';
import img382 from '@images/UI/Fill/social/tiktok/grey@2x.png';
import img383 from '@images/UI/Fill/social/tiktok/grey@3x.png';
import img384 from '@images/UI/Fill/social/tiktok/darkGrey.png';
import img385 from '@images/UI/Fill/social/tiktok/darkGrey@2x.png';
import img386 from '@images/UI/Fill/social/tiktok/darkGrey@3x.png';
import img387 from '@images/UI/Fill/social/tiktok/red.png';
import img388 from '@images/UI/Fill/social/tiktok/red@2x.png';
import img389 from '@images/UI/Fill/social/tiktok/red@3x.png';
import img390 from '@images/UI/Fill/social/tiktok/ultraDG.png';
import img391 from '@images/UI/Fill/social/tiktok/ultraDG@2x.png';
import img392 from '@images/UI/Fill/social/tiktok/ultraDG@3x.png';
import img393 from '@images/UI/Fill/social/vk-video/grey.png';
import img394 from '@images/UI/Fill/social/vk-video/grey@2x.png';
import img395 from '@images/UI/Fill/social/vk-video/grey@3x.png';
import img396 from '@images/UI/Fill/social/vk-video/darkGrey.png';
import img397 from '@images/UI/Fill/social/vk-video/darkGrey@2x.png';
import img398 from '@images/UI/Fill/social/vk-video/darkGrey@3x.png';
import img399 from '@images/UI/Fill/social/vk-video/red.png';
import img400 from '@images/UI/Fill/social/vk-video/red@2x.png';
import img401 from '@images/UI/Fill/social/vk-video/red@3x.png';
import img402 from '@images/UI/Fill/social/vk-video/ultraDG.png';
import img403 from '@images/UI/Fill/social/vk-video/ultraDG@2x.png';
import img404 from '@images/UI/Fill/social/vk-video/ultraDG@3x.png';
import img405 from '@images/UI/Fill/social/vkontakte/grey.png';
import img406 from '@images/UI/Fill/social/vkontakte/grey@2x.png';
import img407 from '@images/UI/Fill/social/vkontakte/grey@3x.png';
import img408 from '@images/UI/Fill/social/vkontakte/darkGrey.png';
import img409 from '@images/UI/Fill/social/vkontakte/darkGrey@2x.png';
import img410 from '@images/UI/Fill/social/vkontakte/darkGrey@3x.png';
import img411 from '@images/UI/Fill/social/vkontakte/red.png';
import img412 from '@images/UI/Fill/social/vkontakte/red@2x.png';
import img413 from '@images/UI/Fill/social/vkontakte/red@3x.png';
import img414 from '@images/UI/Fill/social/vkontakte/ultraDG.png';
import img415 from '@images/UI/Fill/social/vkontakte/ultraDG@2x.png';
import img416 from '@images/UI/Fill/social/vkontakte/ultraDG@3x.png';
import img417 from '@images/UI/Fill/social/youtube/grey.png';
import img418 from '@images/UI/Fill/social/youtube/grey@2x.png';
import img419 from '@images/UI/Fill/social/youtube/grey@3x.png';
import img420 from '@images/UI/Fill/social/youtube/darkGrey.png';
import img421 from '@images/UI/Fill/social/youtube/darkGrey@2x.png';
import img422 from '@images/UI/Fill/social/youtube/darkGrey@3x.png';
import img423 from '@images/UI/Fill/social/youtube/red.png';
import img424 from '@images/UI/Fill/social/youtube/red@2x.png';
import img425 from '@images/UI/Fill/social/youtube/red@3x.png';
import img426 from '@images/UI/Fill/social/youtube/ultraDG.png';
import img427 from '@images/UI/Fill/social/youtube/ultraDG@2x.png';
import img428 from '@images/UI/Fill/social/youtube/ultraDG@3x.png';
import img429 from '@images/UI/Fill/social/telegram/grey.png';
import img430 from '@images/UI/Fill/social/telegram/grey@2x.png';
import img431 from '@images/UI/Fill/social/telegram/grey@3x.png';
import img432 from '@images/UI/Fill/social/telegram/darkGrey.png';
import img433 from '@images/UI/Fill/social/telegram/darkGrey@2x.png';
import img434 from '@images/UI/Fill/social/telegram/darkGrey@3x.png';
import img435 from '@images/UI/Fill/social/telegram/red.png';
import img436 from '@images/UI/Fill/social/telegram/red@2x.png';
import img437 from '@images/UI/Fill/social/telegram/red@3x.png';
import img438 from '@images/UI/Fill/social/telegram/ultraDG.png';
import img439 from '@images/UI/Fill/social/telegram/ultraDG@2x.png';
import img440 from '@images/UI/Fill/social/telegram/ultraDG@3x.png';
import img441 from '@images/UI/Fill/social/rutube/grey.png';
import img442 from '@images/UI/Fill/social/rutube/grey@2x.png';
import img443 from '@images/UI/Fill/social/rutube/grey@3x.png';
import img444 from '@images/UI/Fill/social/rutube/darkGrey.png';
import img445 from '@images/UI/Fill/social/rutube/darkGrey@2x.png';
import img446 from '@images/UI/Fill/social/rutube/darkGrey@3x.png';
import img447 from '@images/UI/Fill/social/rutube/red.png';
import img448 from '@images/UI/Fill/social/rutube/red@2x.png';
import img449 from '@images/UI/Fill/social/rutube/red@3x.png';
import img450 from '@images/UI/Fill/social/rutube/ultraDG.png';
import img451 from '@images/UI/Fill/social/rutube/ultraDG@2x.png';
import img452 from '@images/UI/Fill/social/rutube/ultraDG@3x.png';
import img453 from '@images/UI/Fill/radio-active/red.png';
import img454 from '@images/UI/Fill/radio-active/red@2x.png';
import img455 from '@images/UI/Fill/radio-active/red@3x.png';
import img456 from '@images/UI/Fill/radio-inactive/darkGrey.png';
import img457 from '@images/UI/Fill/radio-inactive/darkGrey@2x.png';
import img458 from '@images/UI/Fill/radio-inactive/darkGrey@3x.png';
import img459 from '@images/UI/Fill/navigation-2/black.png';
import img460 from '@images/UI/Fill/navigation-2/black@2x.png';
import img461 from '@images/UI/Fill/navigation-2/black@3x.png';
import img462 from '@images/UI/Fill/rocket/purple.png';
import img463 from '@images/UI/Fill/rocket/purple@2x.png';
import img464 from '@images/UI/Fill/rocket/purple@3x.png';
import img465 from '@images/UI/Fill/rocket/white.png';
import img466 from '@images/UI/Fill/rocket/white@2x.png';
import img467 from '@images/UI/Fill/rocket/white@3x.png';

export default {
  Fill: {
    at: {
      black: {
        x1: img0,
        x2: img1,
        x3: img2
      }
    },
    couponDiscount: {
      grey: {
        x1: img3,
        x2: img4,
        x3: img5
      }
    },
    trash2: {
      black: {
        x1: img6,
        x2: img7,
        x3: img8
      }
    },
    battery: {
      black: {
        x1: img9,
        x2: img10,
        x3: img11
      }
    },
    fileText: {
      black: {
        x1: img12,
        x2: img13,
        x3: img14
      },
      darkRed: {
        x1: img15,
        x2: img16,
        x3: img17
      }
    },
    wine: {
      black: {
        x1: img18,
        x2: img19,
        x3: img20
      },
      purple: {
        x1: img21,
        x2: img22,
        x3: img23
      }
    },
    undo: {
      red: {
        x1: img24,
        x2: img25,
        x3: img26
      }
    },
    crab: {
      red: {
        x1: img27,
        x2: img28,
        x3: img29
      }
    },
    star_rounded: {
      yellow: {
        x1: img30,
        x2: img31,
        x3: img32
      },
      lightYellow: {
        x1: img33,
        x2: img34,
        x3: img35
      }
    },
    quotations: {
      red: {
        x1: img36,
        x2: img37,
        x3: img38
      }
    },
    playRounded: {
      white: {
        x1: img39,
        x2: img40,
        x3: img41
      }
    },
    info: {
      black: {
        x1: img42,
        x2: img43,
        x3: img44
      },
      darkGrey: {
        x1: img45,
        x2: img46,
        x3: img47
      },
      red: {
        x1: img48,
        x2: img49,
        x3: img50
      }
    },
    car: {
      black: {
        x1: img51,
        x2: img52,
        x3: img53
      },
      orange: {
        x1: img54,
        x2: img55,
        x3: img56
      }
    },
    scale: {
      black: {
        x1: img57,
        x2: img58,
        x3: img59
      }
    },
    qmCircle: {
      darkGrey: {
        x1: img60,
        x2: img61,
        x3: img62
      },
      black: {
        x1: img63,
        x2: img64,
        x3: img65
      }
    },
    alertCircle: {
      black: {
        x1: img66,
        x2: img67,
        x3: img68
      },
      grey: {
        x1: img69,
        x2: img70,
        x3: img71
      },
      lightGrey: {
        x1: img72,
        x2: img73,
        x3: img74
      }
    },
    messageCircle: {
      white: {
        x1: img75,
        x2: img76,
        x3: img77
      },
      darkGrey: {
        x1: img78,
        x2: img79,
        x3: img80
      },
      midGrey: {
        x1: img81,
        x2: img82,
        x3: img83
      },
      red: {
        x1: img84,
        x2: img85,
        x3: img86
      }
    },
    barChart2: {
      midGrey: {
        x1: img87,
        x2: img88,
        x3: img89
      }
    },
    timer: {
      black: {
        x1: img90,
        x2: img91,
        x3: img92
      },
      scarlet: {
        x1: img93,
        x2: img94,
        x3: img95
      },
      red: {
        x1: img96,
        x2: img97,
        x3: img98
      },
      white: {
        x1: img99,
        x2: img100,
        x3: img101
      },
      darkGrey: {
        x1: img102,
        x2: img103,
        x3: img104
      },
      midGrey: {
        x1: img105,
        x2: img106,
        x3: img107
      }
    },
    pricetag: {
      midYellow: {
        x1: img108,
        x2: img109,
        x3: img110
      },
      red: {
        x1: img111,
        x2: img112,
        x3: img113
      },
      black: {
        x1: img114,
        x2: img115,
        x3: img116
      }
    },
    cart: {
      black: {
        x1: img117,
        x2: img118,
        x3: img119
      },
      darkGrey: {
        x1: img120,
        x2: img121,
        x3: img122
      },
      red: {
        x1: img123,
        x2: img124,
        x3: img125
      }
    },
    download: {
      black: {
        x1: img126,
        x2: img127,
        x3: img128
      }
    },
    person: {
      black: {
        x1: img129,
        x2: img130,
        x3: img131
      },
      red: {
        x1: img132,
        x2: img133,
        x3: img134
      },
      darkGrey: {
        x1: img135,
        x2: img136,
        x3: img137
      },
      midGrey: {
        x1: img138,
        x2: img139,
        x3: img140
      }
    },
    personDone: {
      black: {
        x1: img141,
        x2: img142,
        x3: img143
      }
    },
    flash: {
      red: {
        x1: img144,
        x2: img145,
        x3: img146
      }
    },
    share: {
      darkGrey: {
        x1: img147,
        x2: img148,
        x3: img149
      },
      red: {
        x1: img150,
        x2: img151,
        x3: img152
      },
      white: {
        x1: img153,
        x2: img154,
        x3: img155
      },
      black: {
        x1: img156,
        x2: img157,
        x3: img158
      },
      ultraDG: {
        x1: img159,
        x2: img160,
        x3: img161
      }
    },
    fire: {
      red: {
        x1: img162,
        x2: img163,
        x3: img164
      },
      black: {
        x1: img165,
        x2: img166,
        x3: img167
      },
      salmon: {
        x1: img168,
        x2: img169,
        x3: img170
      },
      midGrey: {
        x1: img171,
        x2: img172,
        x3: img173
      }
    },
    carItalic: {
      black: {
        x1: img174,
        x2: img175,
        x3: img176
      },
      white: {
        x1: img177,
        x2: img178,
        x3: img179
      }
    },
    store: {
      ultraDG: {
        x1: img180,
        x2: img181,
        x3: img182
      },
      black: {
        x1: img183,
        x2: img184,
        x3: img185
      },
      red: {
        x1: img186,
        x2: img187,
        x3: img188
      },
      pink: {
        x1: img189,
        x2: img190,
        x3: img191
      },
      white: {
        x1: img192,
        x2: img193,
        x3: img194
      },
      purple: {
        x1: img195,
        x2: img196,
        x3: img197
      }
    },
    award: {
      red: {
        x1: img198,
        x2: img199,
        x3: img200
      },
      midYellow: {
        x1: img201,
        x2: img202,
        x3: img203
      },
      yellow: {
        x1: img204,
        x2: img205,
        x3: img206
      },
      black: {
        x1: img207,
        x2: img208,
        x3: img209
      }
    },
    phone: {
      midYellow: {
        x1: img210,
        x2: img211,
        x3: img212
      },
      yellow: {
        x1: img213,
        x2: img214,
        x3: img215
      },
      black: {
        x1: img216,
        x2: img217,
        x3: img218
      }
    },
    phoneMissed: {
      black: {
        x1: img219,
        x2: img220,
        x3: img221
      }
    },
    phone24: {
      black: {
        x1: img222,
        x2: img223,
        x3: img224
      }
    },
    checkmarkCircle: {
      black: {
        x1: img225,
        x2: img226,
        x3: img227
      },
      grey: {
        x1: img228,
        x2: img229,
        x3: img230
      },
      red: {
        x1: img231,
        x2: img232,
        x3: img233
      },
      purple: {
        x1: img234,
        x2: img235,
        x3: img236
      },
      white: {
        x1: img237,
        x2: img238,
        x3: img239
      }
    },
    bookmark: {
      red: {
        x1: img240,
        x2: img241,
        x3: img242
      },
      darkGrey: {
        x1: img243,
        x2: img244,
        x3: img245
      }
    },
    eye: {
      white: {
        x1: img246,
        x2: img247,
        x3: img248
      },
      darkGrey: {
        x1: img249,
        x2: img250,
        x3: img251
      }
    },
    bell: {
      darkRed: {
        x1: img252,
        x2: img253,
        x3: img254
      }
    },
    heart: {
      black: {
        x1: img255,
        x2: img256,
        x3: img257
      },
      darkRed: {
        x1: img258,
        x2: img259,
        x3: img260
      },
      red: {
        x1: img261,
        x2: img262,
        x3: img263
      }
    },
    star: {
      midYellow: {
        x1: img264,
        x2: img265,
        x3: img266
      },
      red: {
        x1: img267,
        x2: img268,
        x3: img269
      },
      yellow: {
        x1: img270,
        x2: img271,
        x3: img272
      },
      grey: {
        x1: img273,
        x2: img274,
        x3: img275
      }
    },
    closeCircle: {
      darkGrey: {
        x1: img276,
        x2: img277,
        x3: img278
      },
      white: {
        x1: img279,
        x2: img280,
        x3: img281
      }
    },
    close: {
      midGrey: {
        x1: img282,
        x2: img283,
        x3: img284
      }
    },
    gift: {
      red: {
        x1: img285,
        x3: img286,
        x2: img287
      },
      darkRed: {
        x1: img288,
        x3: img289,
        x2: img290
      },
      white: {
        x1: img291,
        x3: img292,
        x2: img293
      },
      dark: {
        x1: img294,
        x3: img295,
        x2: img296
      }
    },
    fastDelivery: {
      red: {
        x1: img297,
        x2: img298,
        x3: img299
      }
    },
    inbox: {
      black: {
        x1: img300,
        x2: img301,
        x3: img302
      }
    },
    calendar: {
      white: {
        x1: img303,
        x2: img304,
        x3: img305
      },
      darkGrey: {
        x1: img306,
        x2: img307,
        x3: img308
      },
      black: {
        x1: img309,
        x2: img310,
        x3: img311
      }
    },
    ruble: {
      black: {
        x1: img312,
        x2: img313,
        x3: img314
      },
      red: {
        x1: img315,
        x2: img316,
        x3: img317
      }
    },
    clock: {
      black: {
        x1: img318,
        x2: img319,
        x3: img320
      },
      grey: {
        x1: img321,
        x2: img322,
        x3: img323
      }
    },
    parking: {
      black: {
        x1: img324,
        x2: img325,
        x3: img326
      }
    },
    pin: {
      black: {
        x1: img327,
        x2: img328,
        x3: img329
      },
      red: {
        x1: img330,
        x2: img331,
        x3: img332
      },
      white: {
        x1: pinWhite,
        x2: pinWhite2x,
        x3: pinWhite3x
      }
    },
    freeDelivery: {
      black: {
        x1: img333,
        x2: img334,
        x3: img335
      },
      red: {
        x1: img336,
        x2: img337,
        x3: img338
      }
    },
    dzen: {
      grey: {
        x1: img339,
        x2: img340,
        x3: img341
      },
      darkGrey: {
        x1: img342,
        x2: img343,
        x3: img344
      },
      red: {
        x1: img345,
        x2: img346,
        x3: img347
      },
      ultraDG: {
        x1: img348,
        x2: img349,
        x3: img350
      }
    },
    max: {
      red: {
        x1: img351,
        x2: img352,
        x3: img353
      },
      ultraDG: {
        x1: img354,
        x2: img355,
        x3: img356
      }
    },
    // 'facebook': {
    //   'grey': {
    //     'x1': img357,
    //     'x2': img358,
    //     'x3': img359
    //   },
    //   'red': {
    //     'x1': img360,
    //     'x2': img361,
    //     'x3': img362
    //   }
    // },
    // 'instagram': {
    //   'grey': {
    //     'x1': img363,
    //     'x2': img364,
    //     'x3': img365
    //   },
    //   'red': {
    //     'x1': img366,
    //     'x2': img367,
    //     'x3': img368
    //   }
    // },
    ok: {
      grey: {
        x1: img369,
        x2: img370,
        x3: img371
      },
      darkGrey: {
        x1: img372,
        x2: img373,
        x3: img374
      },
      red: {
        x1: img375,
        x2: img376,
        x3: img377
      },
      ultraDG: {
        x1: img378,
        x2: img379,
        x3: img380
      }
    },
    tiktok: {
      grey: {
        x1: img381,
        x2: img382,
        x3: img383
      },
      darkGrey: {
        x1: img384,
        x2: img385,
        x3: img386
      },
      red: {
        x1: img387,
        x2: img388,
        x3: img389
      },
      ultraDG: {
        x1: img390,
        x2: img391,
        x3: img392
      }
    },
    vkVideo: {
      grey: {
        x1: img393,
        x2: img394,
        x3: img395
      },
      darkGrey: {
        x1: img396,
        x2: img397,
        x3: img398
      },
      red: {
        x1: img399,
        x2: img400,
        x3: img401
      },
      ultraDG: {
        x1: img402,
        x2: img403,
        x3: img404
      }
    },
    vkontakte: {
      grey: {
        x1: img405,
        x2: img406,
        x3: img407
      },
      darkGrey: {
        x1: img408,
        x2: img409,
        x3: img410
      },
      red: {
        x1: img411,
        x2: img412,
        x3: img413
      },
      ultraDG: {
        x1: img414,
        x2: img415,
        x3: img416
      }
    },
    youtube: {
      grey: {
        x1: img417,
        x2: img418,
        x3: img419
      },
      darkGrey: {
        x1: img420,
        x2: img421,
        x3: img422
      },
      red: {
        x1: img423,
        x2: img424,
        x3: img425
      },
      ultraDG: {
        x1: img426,
        x2: img427,
        x3: img428
      }
    },
    telegram: {
      grey: {
        x1: img429,
        x2: img430,
        x3: img431
      },
      darkGrey: {
        x1: img432,
        x2: img433,
        x3: img434
      },
      red: {
        x1: img435,
        x2: img436,
        x3: img437
      },
      ultraDG: {
        x1: img438,
        x2: img439,
        x3: img440
      }
    },
    rutube: {
      grey: {
        x1: img441,
        x2: img442,
        x3: img443
      },
      darkGrey: {
        x1: img444,
        x2: img445,
        x3: img446
      },
      red: {
        x1: img447,
        x2: img448,
        x3: img449
      },
      ultraDG: {
        x1: img450,
        x2: img451,
        x3: img452
      }
    },
    radioActive: {
      red: {
        x1: img453,
        x2: img454,
        x3: img455
      }
    },
    radioInactive: {
      darkGrey: {
        x1: img456,
        x2: img457,
        x3: img458
      }
    },
    navigation2: {
      black: {
        x1: img459,
        x2: img460,
        x3: img461
      }
    },
    rocket: {
      purple: {
        x1: img462,
        x2: img463,
        x3: img464
      },
      white: {
        x1: img465,
        x2: img466,
        x3: img467
      }
    }
  }
};
